import { useMemo } from 'react';
import { useCampaignSettingsSelector } from './useCampaignSettingsSelector';

export const useCampaignSchedulingSelector = () => {
  const settings = useCampaignSettingsSelector();

  return useMemo(() => settings.scheduling, [settings.scheduling]);
};
